import {PureComponent} from 'react'

import conf from '../../conf.js'

export default class CompanyType extends PureComponent {
  render() {
    const userCompanyType = this.props.user?.company_type ?? ''

    return <div className={this.props.className}>
      { Object.prototype.hasOwnProperty.call(conf.companyTypes, userCompanyType) ? conf.companyTypes[userCompanyType].publicValue : '' }
    </div>
  }
}
